import { render, staticRenderFns } from "./IconSvgPauseCircle.vue?vue&type=template&id=062b28b5&scoped=true&"
import script from "./IconSvgPauseCircle.vue?vue&type=script&lang=js&"
export * from "./IconSvgPauseCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b28b5",
  null
  
)

export default component.exports